import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f0d31d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-card__body group-card__items" }
const _hoisted_2 = { class: "group-card__items-row-data-wrapper" }
const _hoisted_3 = { class: "group-card__items-row" }

import { computed, PropType, ref, watch } from 'vue'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { serviceResultCardCommonProps } from '@/enums/public'
import { useFetchPublicGroupedServicesMutation } from '@/queries/service/serviceGroup'
import { PublicServiceGroupRelation } from '@/models/service/serviceGroup.model'
import PublicServiceGroupItem from '@/components/public/group/PublicServiceGroupItem.vue'
import {
  AnyCreateOrderItemPayload,
  CreateGroupServiceOrderItem,
  GroupedServiceData,
  GroupAvailability,
  GroupAvailabilityItem,
  GroupServiceRelatedServiceItemPayload,
  IGroupAvailabilitySearch,
} from '@/models/public/order.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupedGroupResultCard',
  props: {
  ...serviceResultCardCommonProps,
  availabilitySearch: {
    type: Object as PropType<IGroupAvailabilitySearch | undefined>,
    default: undefined,
  },
  availabilityItem: {
    type: Object as PropType<GroupAvailabilityItem | undefined>,
    default: undefined,
  },
},
  emits: ['update:payload'],
  setup(__props, { emit: emits }) {

const props = __props

const i18n = useI18n()
const toast = useToast()



const updatePayload = (
  gsIndex: number,
  updatedPayload: AnyCreateOrderItemPayload,
) => {
  const existingPayload = props.payload as CreateGroupServiceOrderItem

  const updatedService: PublicServiceGroupRelation =
    groupedServices.value[gsIndex]

  if (!existingPayload) {
    const payload: CreateGroupServiceOrderItem = {
      group_service: props.service?.id,
      items: [],
    }
    payload.items.push({
      related_service: updatedService.service.id,
      payload: updatedPayload,
    })

    emits('update:payload', payload)
    return
  } else {
    const existingPayloadItem = existingPayload.items.find(
      (item: GroupServiceRelatedServiceItemPayload) =>
        item.related_service === updatedService.service.id,
    )
    if (existingPayloadItem) {
      existingPayloadItem.payload = updatedPayload
    } else {
      existingPayload.items.push({
        related_service: updatedService.service.id,
        payload: updatedPayload,
      })
    }

    emits('update:payload', existingPayload)
    return
  }
}
const groupedServicesData = ref<GroupedServiceData[]>([])

const groupedServices = computed<PublicServiceGroupRelation[]>(() => {
  return groupedServicesData.value.map(
    (item: GroupedServiceData) => item.groupedService,
  )
})

const groupedServiceAvailabilityItems = computed<
  Array<GroupAvailabilityItem | undefined>
>(() => {
  if (!props.availabilityItem || !props.availabilityItem?.availability) {
    return
  }

  const groupAvailability: GroupAvailability = props.availabilityItem
    ?.availability as GroupAvailability

  const groupedItemAvailabilities = groupAvailability.items ?? []
  return groupedServicesData.value.map((data: GroupedServiceData) => {
    return groupedItemAvailabilities.find(
      (availabilityItem: GroupAvailabilityItem) => {
        return (
          availabilityItem.service.hash_id ===
          data.groupedService.service.hash_id
        )
      },
    )
  })
})

const groupedServicePayloads =
  computed<Array<AnyCreateOrderItemPayload> | null>(() => {
    if (!props.payload) return null
    const payload = props.payload as CreateGroupServiceOrderItem

    if (!payload) return
    return groupedServicesData.value.map((item: GroupedServiceData) => {
      return payload.items.find(
        (payloadItem: GroupServiceRelatedServiceItemPayload) => {
          return payloadItem.payload?.service === item.groupedService.service.id
        },
      )
    })
  })

const { mutateAsync: fetchGroupedServices } =
  useFetchPublicGroupedServicesMutation(
    ref(props.service.hash_id),
    props.isPreview,
  )

fetchGroupedServices()
  .then((data: PublicServiceGroupRelation[]) => {
    groupedServicesData.value = data.map((item) => ({
      groupedService: item,
      payload: null,
    }))
  })
  .catch(() => {
    toast.error(i18n.t('dataLoadError'))
  })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group-card", { 'result-card--grouped': !!props.groupService }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedServices), (groupedService, gsIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: groupedService.service.hash_id
            }, [
              (!groupedService.is_service_hidden)
                ? (_openBlock(), _createBlock(PublicServiceGroupItem, {
                    key: groupedService.service.hash_id,
                    value: groupedService,
                    "group-service": groupedService.service.hash_id,
                    "is-preview": false,
                    "enable-ordering": true,
                    "availability-search": __props.availabilitySearch,
                    "availability-item": _unref(groupedServiceAvailabilityItems)[gsIndex],
                    payload: _unref(groupedServicePayloads)?.[gsIndex],
                    "onUpdate:payload": 
                (payload) => {
                  updatePayload(gsIndex, payload)
                }
              
                  }, null, 8, ["value", "group-service", "availability-search", "availability-item", "payload", "onUpdate:payload"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})